var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: { "text-align": "left", width: "100%", height: "100%" },
      attrs: { id: "login-container" }
    },
    [
      _c("div", {
        staticStyle: {
          height: "36px",
          "line-height": "36px",
          "padding-top": "20px",
          "margin-left": "200px"
        }
      }),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: {
            "text-align": "center",
            width: "1000px",
            height: "calc(100% - 356px)",
            margin: "150px auto"
          }
        },
        [
          _c("el-col", {
            staticStyle: {
              width: "550px",
              height: "100%",
              display: "flex",
              "align-items": "center"
            },
            attrs: { span: 24 }
          }),
          _vm._v(" "),
          _c(
            "el-col",
            {
              staticStyle: {
                width: "400px",
                height: "100%",
                display: "flex",
                "align-items": "center"
              },
              attrs: { span: 5 }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    width: "400px",
                    background: "#fff",
                    "border-radius": "4px",
                    padding: "30px 50px"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "login-type",
                      staticStyle: { "font-size": "18px", color: "#42464F" }
                    },
                    [_vm._v("注册")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading"
                        }
                      ],
                      ref: "registerForm",
                      staticClass: "login-form",
                      attrs: {
                        model: _vm.registerForm,
                        rules: _vm.rules,
                        "label-position": "left",
                        "label-width": "0px"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "text",
                              "auto-complete": "off",
                              placeholder: "姓名"
                            },
                            model: {
                              value: _vm.registerForm.name,
                              callback: function($$v) {
                                _vm.$set(_vm.registerForm, "name", $$v)
                              },
                              expression: "registerForm.name"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "phone", error: _vm.errorMsg } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "text",
                              id: "phone",
                              "auto-complete": "off",
                              placeholder: "手机号"
                            },
                            model: {
                              value: _vm.registerForm.phone,
                              callback: function($$v) {
                                _vm.$set(_vm.registerForm, "phone", $$v)
                              },
                              expression: "registerForm.phone"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "captcha" } },
                        [
                          _c("el-input", {
                            staticClass: "captcha",
                            staticStyle: { width: "58%" },
                            attrs: {
                              id: "captcha",
                              type: "text",
                              "auto-complete": "off",
                              placeholder: "请输入验证码"
                            },
                            model: {
                              value: _vm.registerForm.captcha,
                              callback: function($$v) {
                                _vm.$set(_vm.registerForm, "captcha", $$v)
                              },
                              expression: "registerForm.captcha"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "captcha",
                              staticStyle: { width: "40%" },
                              attrs: {
                                type: _vm.show ? "primary" : "info",
                                disabled: (_vm.disabled = !_vm.show)
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.receiveCaptcha.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.show,
                                      expression: "show"
                                    }
                                  ]
                                },
                                [_vm._v("获取验证码")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.show,
                                      expression: "!show"
                                    }
                                  ],
                                  staticClass: "count"
                                },
                                [_vm._v(_vm._s(_vm.count) + "s后重新获取")]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "aliAccount" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "text",
                              "auto-complete": "off",
                              placeholder: "支付宝账号"
                            },
                            model: {
                              value: _vm.registerForm.aliAccount,
                              callback: function($$v) {
                                _vm.$set(_vm.registerForm, "aliAccount", $$v)
                              },
                              expression: "registerForm.aliAccount"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "school" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "text",
                              "auto-complete": "off",
                              placeholder: "学校"
                            },
                            model: {
                              value: _vm.registerForm.school,
                              callback: function($$v) {
                                _vm.$set(_vm.registerForm, "school", $$v)
                              },
                              expression: "registerForm.school"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "password" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "password",
                              "auto-complete": "off",
                              placeholder: "密码(6-16位字符组成)"
                            },
                            model: {
                              value: _vm.registerForm.password,
                              callback: function($$v) {
                                _vm.$set(_vm.registerForm, "password", $$v)
                              },
                              expression: "registerForm.password"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%", "margin-bottom": "5px" }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "primary",
                                disabled: !(
                                  _vm.clicked && _vm.registerForm.agreement
                                )
                              },
                              on: { click: _vm.register }
                            },
                            [_vm._v("注册")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        {
                          staticClass: "lx-aggrement",
                          staticStyle: {
                            "text-align": "left",
                            "margin-bottom": "20px"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            [
                              _c(
                                "el-checkbox",
                                {
                                  model: {
                                    value: _vm.registerForm.agreement,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.registerForm,
                                        "agreement",
                                        $$v
                                      )
                                    },
                                    expression: "registerForm.agreement"
                                  }
                                },
                                [_vm._v("阅读并接受")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    target: "_blank",
                                    href: "/agreement/1.html"
                                  }
                                },
                                [_vm._v("《天天乐学网用户协议》")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "forget-pwd",
                          on: { click: _vm.directLogin }
                        },
                        [_vm._v("已有帐号，直接登录>")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-7bf3755a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-7bf3755a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/Register.vue
// module id = null
// module chunks = 